import React, { useContext, useEffect, useState } from 'react';
import moment from 'moment-timezone';
import { formatPimDate } from '@mummssoftware/utils/formatters';
import { hhmmToMin } from '@mummssoftware/utils/timeUtils';
import {
  VisitsGlobalContext,
  SET_START_TIME,
} from '@mummssoftware/global-context';
import {
  isUserNurseAideRoleGroup,
  hasTimerDuration,
  isAgencyEnabled,
} from '@mummssoftware/utils/utils';
import {
  addMomentMins,
  dateAsMoment,
  utcToTz,
  dateToMoment,
} from '@mummssoftware/utils/dates';
import { EditStartTime, EditEndTime } from '@mummssoftware/common-ui';
import EditableTimer from './EditableTimer';
import CCTimer from './CCTimer';
import { EditVisitDiv } from './styledDiv';
import { AppContext } from '../../../../context';

// todo is30MinAgency
// todo IPUVisit

type EditTimeProps = {
  pastVisit: Record<string, any>;
};

const getEndTime = (startTime: any, timerDuration: any, durationmins: any) => {
  const durationMins = hasTimerDuration(timerDuration)
    ? hhmmToMin(timerDuration[0], timerDuration[1])
    : durationmins;
  // todo use effect update end time from timer duration
  const addDuration = addMomentMins(durationMins);
  const getEndFromStartDate = dateAsMoment(addDuration);

  const endTime = getEndFromStartDate(startTime);
  return endTime;
};

export const EditTime = ({ pastVisit }: EditTimeProps) => {
  const { timerDuration, dispatchVG, startTime } = useContext(
    VisitsGlobalContext,
  );
  const { currentUser } = useContext(AppContext);
  const { continuouscarehours, durationmins } = pastVisit;
  const isCCRoleGroup = isUserNurseAideRoleGroup(currentUser);

  // 15 min increment for selected agencies
  const increment30MinVisitBins: string = window.env
    ?.increment30MinVisitBins as string;
  const is30MinAgency = isAgencyEnabled(increment30MinVisitBins, currentUser);

  const timezone = currentUser.siteTimezone || moment.tz.guess();
  const savedStartTime = pastVisit?.effectivedatetime
    ? utcToTz(pastVisit?.effectivedatetime, timezone)
    : new Date();
  const [startEditTime, setStartTime] = useState(savedStartTime);
  const initEndTime = getEndTime(startEditTime, timerDuration, durationmins);
  const [endTime, setEndTime] = useState(initEndTime);

  const onStartTimeChange = (newTime: Date) => {
    setStartTime(newTime);
    const start = dateToMoment(newTime); // dateToMoment splices out timezone
    const startDate = formatPimDate(start);
    const endDate = getEndTime(newTime, timerDuration, durationmins);
    setEndTime(endDate as any);
    dispatchVG({
      type: SET_START_TIME,
      payload: startDate,
    });
  };

  useEffect(() => {
    if (hasTimerDuration(timerDuration)) {
      const endDate = getEndTime(startEditTime, timerDuration, durationmins);
      setEndTime(endDate);
    }
  }, [timerDuration]);

  useEffect(() => {
    if (startTime) {
      const updatedTime = utcToTz(startTime as any, timezone);
      setStartTime(updatedTime);
    }
  }, [startTime]);

  return (
    <EditVisitDiv id="visit-log-edit-time">
      <EditStartTime
        startTime={startEditTime}
        onChange={onStartTimeChange}
        is30MinAgency={!!is30MinAgency}
      />
      <EditableTimer durationmins={durationmins} />
      <EditEndTime endTime={endTime} />
      <CCTimer
        isCCRoleGroup={isCCRoleGroup}
        continuouscarehours={continuouscarehours}
      />
      {/* {(!IPUVisit || appVisit?.source === SCIPU) && (
        <CCTimer isCCRoleGroup={isCCRoleGroup} />
      )} */}
    </EditVisitDiv>
  );
};
export default EditTime;
